"use client";

import dynamic from "next/dynamic";
import useSearchListingPropertiesCount from "hooks/swr/useSearchListingPropertiesCount";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
const HeaderSearch = dynamic(() => import( /* webpackChunkName: "HeaderSearch" */"components/modals/search-bar-model"));
const FilterProperty = dynamic(() => import( /* webpackChunkName: "FilterProperty" */"components/pages/vacation-rentals/MoreFilters/FilterProperty"), {
  ssr: false
});
const SearchPill = () => {
  const [isLargerThan992] = useMediaQuery("(min-width: 992px)");
  const {
    data: countApiResponse
  } = useSearchListingPropertiesCount();
  return <div data-sentry-component="SearchPill" data-sentry-source-file="SearchPill.tsx">
      {/* // search bar [desktop view] for the vacation-rental page */}
      {isLargerThan992 && <div className='flex items-center gap-2 lg4:gap-[15px]'>
          <HeaderSearch />
          <FilterProperty expandedMiles={countApiResponse?.expandedRadiusMiles} />
        </div>}
    </div>;
};
export default SearchPill;